import routes from './routes';

export default {
  id: 'crmKanban',
  routes,
};
